class JobCandidatesCompareController {
    /*@ngInject*/
    constructor($rootScope, $timeout, jobService, userRoleService, jobMatchActionsService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.userRoleService = userRoleService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        $('.modal').css("overflow-y", "scroll");
        this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
        this.isJobMatchPanelOpen = true;
        this.isEducationPanelOpen = true;
        this.isExperiencePanelOpen = true;
        this.isTechnicalSkillsPanelOpen = true;
        this.isOperationalSkillsPanelOpen = true;
        this.isSoftSkillsPanelOpen = true;
        this.isOtherSkillsPanelOpen = true;
        this.isCertificationsPanelOpen = true;
        this.isCompensationPanelOpen = true;
        this.isSalaryPanelOpen = true;
        this.isSponsorshipsPanelOpen = true;
        this.isRelocationPanelOpen = true;
        this.isAdditionalInformationPanelOpen = true;
        this.togglePanelsLabel = 'Collapse All';
        this.isAllPanelsOpen = true;
        //variables
        this.comparisonData = [];
        this.panelClasses = ['education-assets', 'experience-assets', 'tech-assets', 'operational-assets', 'soft-assets', 'certification-assets', 'other-assets', 'compensation-assets', 'salary-assets', 'sponsorship-assets', 'relocation-assets'];
        this.panelBootStrapColumnWidthClass = 'col-xs-3';
        this.companyId = this.$rootScope.userDetails.company.companyId;
        //flags
        this.loadingFlag = true;
        this.panelBootStrapColumnWidthClass = this.candidateIds.split(',').length == '2' ? 'col-xs-4' : 'col-xs-3';
        // get the job candidates comparison
        this.multipleCandidatesSingleJobComparison();
    }
    togglePanels() {
        this.isAllPanelsOpen = !this.isAllPanelsOpen;
        this.togglePanelsLabel = this.isAllPanelsOpen ? 'Collapse All' : 'Expand All';
        this.isJobMatchPanelOpen = this.isAllPanelsOpen;
        this.isEducationPanelOpen = this.isAllPanelsOpen;
        this.isExperiencePanelOpen = this.isAllPanelsOpen;
        this.isTechnicalSkillsPanelOpen = this.isAllPanelsOpen;
        this.isOperationalSkillsPanelOpen = this.isAllPanelsOpen;
        this.isSoftSkillsPanelOpen = this.isAllPanelsOpen;
        this.isOtherSkillsPanelOpen = this.isAllPanelsOpen;
        this.isCertificationsPanelOpen = this.isAllPanelsOpen;
        this.isCompensationPanelOpen = this.isAllPanelsOpen;
        this.isSalaryPanelOpen = this.isAllPanelsOpen;
        this.isSponsorshipsPanelOpen = this.isAllPanelsOpen;
        this.isRelocationPanelOpen = this.isAllPanelsOpen;
        this.isAdditionalInformationPanelOpen = this.isAllPanelsOpen;
        this.workflowSteps.forEach(step => {
            step.isOpen = this.isAllPanelsOpen;
        });
    }
    multipleCandidatesSingleJobComparison() {
        this.loadingFlag = true;
        this.jobService.multipleCandidatesSingleJobComparison(this.jobId, this.candidateIds, this.companyId, (data) => {
            this.comparisonData = data.multipleCandidateSingleJobComparisonDetails;
            this.workflowSteps = this._getMassagedWorkflowSteps(data.workFlowSteps);
            this._massageComparisonData();
            this.loadingFlag = false;
            this._setHeightsOfPanels();
            this.initializeSliders();
        }, (error) => {
            this.loadingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _getMassagedWorkflowSteps(workflowStepsData) {
        let workflowSteps = [];
        for (let stepKey in workflowStepsData) {
            workflowSteps.push({ step: workflowStepsData[stepKey], isOpen: true });
        }
        return workflowSteps;
    }
    _massageComparisonData() {
        angular.forEach(this.comparisonData, (comparison, key) => {
            angular.forEach(comparison.educationComparisons, (experience, expKey) => {
                if (experience.candidateInstituteName === null || experience.candidateInstituteName === "") {
                    experience.candidateInstituteName = "'Unknown'";
                }
            });
            comparison.educationComparisonsGrouped = [];
            if (comparison.educationComparisons) {
                const groupedDegrees = this.groupBy(comparison.educationComparisons, 'jobDegreeName');
                for (let degree in groupedDegrees) {
                    let institutes = groupedDegrees[degree];
                    let institutesText = "";
                    institutes.forEach((institution, key) => {
                        institutesText = `<span> ${institutesText} ${institution.candidateDegreeName} at ${institution.candidateInstituteName}</span><br>`;
                    });
                    let institute = groupedDegrees[degree][0];
                    institute.text = institutesText;
                    comparison.educationComparisonsGrouped.push(institute);
                }
            }
            if (comparison.latestEducationDto) {
                if (comparison.latestEducationDto.candidateInstituteName === null || comparison.latestEducationDto.candidateInstituteName === "") {
                    comparison.latestEducationDto.candidateInstituteName = "'Unknown'";
                }
            }
            angular.forEach(comparison.experienceComparisons, (experience, expKey) => {
                if (experience.company === null || experience.company === "") {
                    experience.company = "'Unknown'";
                }
            });
            comparison.jobMatchScore = Math.floor(parseFloat(comparison.jobMatchScore));
            if (comparison.workflowStepsComparisons) {
                if (comparison.workflowStepsComparisons.techAssessmentComparisons && comparison.workflowStepsComparisons.techAssessmentComparisons.score) {
                    comparison.workflowStepsComparisons.techAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.techAssessmentComparisons.score));
                }
                if (comparison.workflowStepsComparisons.valueAssessmentComparisons && comparison.workflowStepsComparisons.valueAssessmentComparisons.score) {
                    comparison.workflowStepsComparisons.valueAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.valueAssessmentComparisons.score));
                }
            }
            comparison.technicalSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.operationalSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.softSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.otherSkillCounts = {
                additional: 0
            };
            angular.forEach(comparison.technicalSkillComparisons, (skill, expKey) => {
                if (skill.status === 'MATCH') {
                    comparison.technicalSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.technicalSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.technicalSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.technicalSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.operationalSkillComparisons, (skill, expKey) => {
                if (skill.status === 'MATCH') {
                    comparison.operationalSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.operationalSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.operationalSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.operationalSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.softSkillComparisons, (skill, expKey) => {
                if (skill.status === 'MATCH') {
                    comparison.softSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.softSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.softSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.softSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.otherComparisons, (skill, expKey) => {
                if (skill.status === 'ADDITIONAL') {
                    comparison.otherSkillCounts.additional++;
                }
            });
        });
        this.jobDetails = angular.copy(this.comparisonData[0]);
    }
    groupBy(objectArray, property) {
        return objectArray.reduce((acc, obj) => {
            const key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            // Add object to list for given key's value
            acc[key].push(obj);
            return acc;
        }, {});
    }
    _setHeightsOfPanels() {
        // make height of each division equal so that the compare view is easier to look at horizontally.
        this.$timeout(() => {
            angular.forEach(this.panelClasses, (val, key) => {
                // get each panel / category type
                var panelsArray = $("." + val);
                // get an array of lengths of 'li' items within each panel
                var lengths = panelsArray.map((key, panel) => {
                    return $(panel).children('li').length;
                }).get();
                // get the maximum number of 'li' per panel
                var maxLength = Math.max.apply(null, lengths);
                for (var i = 0; i < maxLength; i++) {
                    // for each of the list of 'li' s
                    var maxHeight = 0;
                    // find the maximum height among the 'li' s in the horizontal row
                    angular.forEach(panelsArray, (val, key) => {
                        // in each of the panels / categories, find the max height of the li
                        var liItem = $(val).children('li')[i];
                        if (!_.isUndefined(liItem) && $(liItem).height() > maxHeight) {
                            maxHeight = $(liItem).height();
                        }
                    });
                    // for each li, set it to the max height
                    angular.forEach(panelsArray, (val, key) => {
                        var liItem = $(val).children('li')[i];
                        if (!_.isUndefined(liItem)) {
                            $(liItem).height(maxHeight);
                            // $(liItem).css('margin-bottom','5px');
                            $(liItem).css('margin', '0px -18px 3px -18px');
                            $(liItem).css('padding-left', '40px');
                            $(liItem).css('padding-right', '4px');
                            // for every even entry, set the background as very light grey
                            if (i % 2 == 0) {
                                $(liItem).css('background', '#efefef');
                            }
                        }
                    });
                }
                // after the horizontal li's have been adjusted to be same height, set the panels to all have same height
                // this is to account for the extra 'li' s some panels might have
                var heights = panelsArray.map((key, panel) => {
                    return $(panel).height();
                }).get();
                var maxHeight = Math.max.apply(null, heights);
                $("." + val).height(maxHeight);
            });
        }, 200);
    }
    isComparisonEmpty(comparison) {
        return angular.equals(comparison, {});
    }
    getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId) {
        this.jobMatchActionsService.getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, 'job-candidates-compare');
    }
    viewFeedback(feedbackType, label, candidateId, jobMatchId) {
        let feedbackDetails = {
            candidateId: candidateId,
            jobId: this.jobId,
            jobMatchId: jobMatchId,
            feedbackType: feedbackType,
            label: label,
            context: 'jobCandidatesCompare'
        };
        this.jobMatchActionsService.openFeedbackModal(feedbackDetails);
    }
    initializeSliders() {
        this.$timeout(() => {
            $("div[class='overall-qn-slider']").each((i, obj) => {
                let jobMatchId = obj.id.split('__')[1].split('_')[0];
                let questionId = obj.id.split('__')[1].split('_')[1];
                let labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                let candidate = this.comparisonData.find(candidate => candidate.jobMatchId === jobMatchId);
                let feedback = candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks ? candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
            $("div[class='overall-qn-slider_ps']").each((i, obj) => {
                let jobMatchId = obj.id.split('__')[1].split('_')[0];
                let questionId = obj.id.split('__')[1].split('_')[1];
                let labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId + '_ps';
                ;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                let candidate = this.comparisonData.find(candidate => candidate.jobMatchId === jobMatchId);
                let feedback = candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks ? candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
            $("div[class='overall-qn-slider_in']").each((i, obj) => {
                let jobMatchId = obj.id.split('__')[1].split('_')[0];
                let questionId = obj.id.split('__')[1].split('_')[1];
                let labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId + '_in';
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: () => {
                        let val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                let candidate = this.comparisonData.find(candidate => candidate.jobMatchId === jobMatchId);
                let feedback = candidate.workflowStepsComparisons.interviewComparisons.feedbacks ? candidate.workflowStepsComparisons.interviewComparisons.feedbacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
        }, 200);
    }
}
JobCandidatesCompareController.$inject = ['$rootScope', '$timeout', 'jobService', 'userRoleService', 'jobMatchActionsService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './job-candidates-compare.html';
import * as TEMPLATE from 'raw-loader!./job-candidates-compare.html';
export const JobCandidatesCompareComponent = {
    selector: 'jobCandidatesCompare',
    component: {
        bindings: {
            jobId: '@',
            candidateIds: '@'
        },
        controller: JobCandidatesCompareController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/jobCandidatesCompare/job-candidates-compare.html'
    }
};
//# sourceMappingURL=job-candidates-compare.component.js.map